import { createGlobalStyle, css } from "styled-components";
import { GolosFontFaceRules, RobotoFontFaceRules } from "./fontFaceRuleSets"; // Имя класса для блокировки overflow на body, используется в Popup

export var SCROLL_DISABLE_CLASSNAME = "pochta-ui-scroll-disable";
/** Шрифтовые глобальные стили для body */

export var GlobalBodyFontStyles = createGlobalStyle(function (_ref) {
  var theme = _ref.theme;
  return css(["body{font-family:", ";font-size:", ";color:", ";}.", "{overflow:hidden;}"], theme.font.fontFamily, theme.font.sizes[theme.font.defaultSize].fontSize, theme.font.color, SCROLL_DISABLE_CLASSNAME);
});
export var GlobalStylesWithGolos = createGlobalStyle(["", ";"], GolosFontFaceRules);
export var GlobalStylesWithRoboto = createGlobalStyle(["", ";"], RobotoFontFaceRules);